const Layout = () => import( "@/views/Layout");
const briefIntroduction = () => import( "@/views/briefIntroduction");

export default [
    {
        path: "/brief-introduction",
        component: Layout,
        meta: {
            title: '扩展介绍',
            // titleEn: 'INTRODUCTION'
            titleEn: 'About Us'
        },
        children: [
            {
                path: '',
                component: briefIntroduction
            }
        ]
    }
]